// 필수 데이터 API
import HTTP from 'apiDefault'

// 필수 데이터 목록 조회
const getList = (accountID) => {
  return HTTP.get(`/requirement/${accountID}/list`
    ,{ headers: { Authorization:window._VUE_STATE.header }, }
    )
}

export {
  getList,
}



// WEBPACK FOOTER //
// ./src/api/requirement.js